import React, { useMemo } from "react";
import { ModalDialogBase, ModalDialogBaseProps } from "./ModalDialogBase";
import ModalDialogConfirmButtons from "./ModalDialogConfirmButtons";

export interface ModalDialogConfirmSimpleProps
  extends Omit<
    ModalDialogBaseProps,
    "actionsSection" | "statusSection" | "resultSection"
  > {
  //Action button props
  defaultButton?: "OK" | "CANCEL";
  cancelButtonText?: string;
  cancelButtonDisabled?: boolean;
  onCancelButtonClick?: () => void;
  okButtonText?: string;
  okButtonDisabled?: boolean;
  okButtonWarningColor?: boolean;
  onOKButtonClick?: () => void;
}

/* This component displays a simple Modal Confirmation Dialog box
With two buttons, Cancel and OK.  Button names and behaviors can be
customized with props */
export const ModalDialogConfirmSimple: React.FC<
  ModalDialogConfirmSimpleProps
> = ({
  //Dialog Props
  open,
  fullWidth = false,
  maxWidth = false,
  forceOnTop = false,

  title = "",
  onClose,
  disableEscapeKeyDown = false,
  disableCloseOnBackdropClick = false,

  contentSection,

  //Action button props
  defaultButton = "CANCEL",
  cancelButtonText = "Cancel",
  cancelButtonDisabled = false,
  onCancelButtonClick,
  okButtonText = "OK",
  okButtonDisabled = false,
  okButtonWarningColor = false,
  onOKButtonClick,
}) => {
  //Build the actions section with standard Cancel and OK buttons
  const actionsSection = useMemo(
    () => (
      <ModalDialogConfirmButtons
        defaultButton={defaultButton}
        cancelButtonText={cancelButtonText}
        cancelButtonDisabled={cancelButtonDisabled}
        onCancelButtonClick={onCancelButtonClick}
        okButtonText={okButtonText}
        okButtonDisabled={okButtonDisabled}
        okButtonWarningColor={okButtonWarningColor}
        onOKButtonClick={onOKButtonClick}
      />
    ),
    [
      defaultButton,
      cancelButtonText,
      cancelButtonDisabled,
      onCancelButtonClick,
      okButtonText,
      okButtonDisabled,
      okButtonWarningColor,
      onOKButtonClick,
    ]
  );

  return (
    <ModalDialogBase
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      forceOnTop={forceOnTop}
      title={title}
      onClose={onClose}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableCloseOnBackdropClick={disableCloseOnBackdropClick}
      contentSection={contentSection}
      actionsSection={actionsSection}
    />
  );
};

export default ModalDialogConfirmSimple;
